import { useState } from "react";
import { MessageSquare } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import ContactForm from "@/components/landing/ContactForm";

export const ContactFab = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid="contact-fab"
        aria-label="Quick contact"
        className="fixed bottom-6 right-6 z-50 inline-flex items-center gap-2.5 px-5 py-3.5 rounded-full bg-[#9E1B32] text-white font-semibold text-[15px] shadow-[0_8px_24px_-4px_rgba(158,27,50,0.6)] hover:bg-[#7A1426] hover:scale-[1.03] active:scale-95 transition-[background-color,transform]"
      >
        <MessageSquare size={18} />
        <span className="hidden sm:inline">Reach out</span>
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md rounded-[14px]" data-testid="contact-fab-dialog">
          <DialogHeader>
            <DialogTitle className="text-xl font-bold tracking-tight">Reach out to Dhwani RIS</DialogTitle>
            <DialogDescription className="text-[#5C5F6B]">
              Share your details and our partnerships team will get in touch.
            </DialogDescription>
          </DialogHeader>
          <ContactForm idPrefix="fab" onSuccess={() => setOpen(false)} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ContactFab;
